import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { ScriptGuru } from '../../helper/script.guru';
import { UtilitesService } from '../../services';

@Directive({
  selector: '[appunwraptag]'
})
export class UnwrapTagDirective implements AfterViewInit {
  constructor(private el: ElementRef, private lib: UtilitesService) { }
  ngAfterViewInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    this.lib.script.unwrapTag(nativeElement);
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/directives/control/unwrap-tag.ts